<template>
    <section class="section columns is-centered">
        <div class="column is-6">
            <div class="box">
                <form action="" @submit.prevent="checkForm">
                    <div class="field">
                        <label v-t="'Register.name'" class="label" />
                        <div class="control">
                            <input
                                id="name"
                                v-model="name"
                                class="input"
                                autocomplete="name"
                                type="text"
                            />
                        </div>
                        <p
                            v-t="'Register.name_hint'"
                            class="help has-text-grey-light"
                        />
                    </div>
                    <div class="field">
                        <label v-t="'Register.email'" class="label" />
                        <div class="control has-icons-right">
                            <input
                                id="email"
                                v-model="email"
                                autocomplete="email"
                                class="input"
                                type="email"
                            />
                            <span
                                v-if="!emailIsValid && email"
                                class="icon is-small is-right"
                            >
                                <i
                                    class="fas fa-exclamation-triangle has-text-danger"
                                ></i>
                            </span>
                        </div>
                        <p
                            v-t="'Register.email_hint'"
                            class="help has-text-grey-light"
                        />
                    </div>
                    <div class="field">
                        <label v-t="'Register.password'" class="label" />
                        <div class="control has-icons-right">
                            <input
                                v-model="password"
                                class="input"
                                autocomplete="new-password"
                                type="password"
                            />
                            <span
                                v-if="!passwordIsValid && password"
                                class="icon is-small is-right"
                            >
                                <i
                                    class="fas fa-exclamation-triangle has-text-danger"
                                ></i>
                            </span>
                        </div>
                        <p
                            v-t="'Register.password_hint'"
                            class="help has-text-grey-light"
                        />
                    </div>

                    <div class="field">
                        <label v-t="'Register.school_code'" class="label" />
                        <div class="control has-icons-right">
                            <input
                                v-model="schoolCode"
                                class="input"
                                type="text"
                            />
                        </div>
                        <p
                            v-t="'Register.school_code_hint'"
                            class="help has-text-grey-light"
                        />
                    </div>
                    <nav class="level is-mobile">
                        <div class="level-left"></div>
                        <div class="level-right">
                            <div class="field is-grouped is-pulled-right">
                                <div class="control">
                                    <button
                                        v-t="'Register.register'"
                                        :class="{ 'is-loading': sendingData }"
                                        :disabled="sendingData"
                                        class="button is-link"
                                    />
                                </div>
                            </div>
                        </div>
                    </nav>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
import { toast } from 'bulma-toast';
import { register } from '@/services/API';
export default {
    data() {
        return {
            name: undefined,
            email: undefined,
            password: undefined,
            schoolCode: undefined,
            sendingData: false,
        };
    },
    computed: {
        emailIsValid() {
            var re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(this.email);
        },
        passwordIsValid() {
            var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
            return re.test(this.password);
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
    },
    methods: {
        checkForm() {
            if (!this.name) {
                this.displayMessage(
                    this.$t('Register.errors.no_name'),
                    'is-danger'
                );
                return false;
            }
            if (!this.emailIsValid) {
                this.displayMessage(
                    this.$t('Register.errors.invalid_mail'),
                    'is-danger'
                );
                return false;
            }
            if (!this.passwordIsValid) {
                this.displayMessage(
                    this.$t('Register.errors.invalid_password'),
                    'is-danger'
                );
                return false;
            }
            this.sendingData = true;
            register({
                name: this.name,
                email: this.email,
                password: this.password,
                schoolCode: this.schoolCode,
            })
                .then((result) => {
                    this.$store
                        .dispatch('localLogin', {
                            username: this.email,
                            password: this.password,
                        })
                        .then(() => {
                            this.$router.push({
                                name: 'dashboard',
                                query: {
                                    filter: 'mine',
                                },
                            });
                        });
                })
                .catch((e) => {
                    this.sendingData = false;
                    this.displayMessage(this.$t(e.data), 'is-danger');
                })
                .finally(() => {
                    this.sendingData = false;
                });
        },
        displayMessage(text, type) {
            toast({
                message: text,
                type: type,
                dismissible: false,
                duration: 5000,
                pauseOnHover: true,
                position: 'center',
                animate: { in: 'fadeIn', out: 'fadeOut' },
            });
        },
    },
};
</script>

<style></style>
